import { ReactNode } from 'react';
import classNames from 'classnames';
import { shallowEqual } from 'react-redux';

import { useAppSelector } from '../../../hooks/useAppSelector';

// Wraps the absolute-positioned banner row that floats above the map and
// shrinks/expands with the Layer/Cart side panels. Owns the redux subscription
// so each banner (StaffPriceEditBanner, ShapeOverrideConfirmBanner,
// RealtimeInfoBanner) doesn't re-implement the same shrink/expand classNames.
// SCSS half lives at `%map-overlay-banner-shell` in abstracts/_placeholders.scss.
const MapOverlayShell = ({
  className,
  children,
}: {
  className: string;
  children: ReactNode;
}) => {
  const { layersPanelVisible, rightMenuVisible } = useAppSelector(
    (s) => ({
      layersPanelVisible: s.layout.layersPanel.isVisible,
      rightMenuVisible: s.layout.rightMenu.isVisible,
    }),
    shallowEqual
  );
  return (
    <div
      className={classNames(className, {
        'layers-panel-visible': layersPanelVisible,
        'right-menu-visible': rightMenuVisible,
      })}
    >
      {children}
    </div>
  );
};

export default MapOverlayShell;
